import BalanceCellRenderer from './BalanceCellRenderer'
import messageResource from '../../../../messageResource'
function SickDaysCellRenderer ()
{
    this.constructor = SickDaysCellRenderer;
}

SickDaysCellRenderer.prototype = _.create(BalanceCellRenderer.prototype, {

    getCellGeneralClassName: function()
    {
        return BalanceCellRenderer.prototype.getCellGeneralClassName.call(this) + " sickDaysCell";
    },

    roundBalance: function()
    {
        return window.SystemSettings.roundSickBalanceOnUserlist;
    },

    getFlagValue: function(value)
    {
        return value.sick;
    },

    getCurrentBalanceFromValue: function(value)
    {
        return value.currentSickDaysBalance;
    },

    showBalanceInHours: function()
    {
        return window.SystemSettings.showSickInHours;
    },

    getNotStartedText: function()
    {
        return messageResource.getEscapedMessage("userlist.js.table.sickCell.not_started");
    }
});

export default SickDaysCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysCellRenderer.js